import React from 'react'
import differenceInDays from 'date-fns/differenceInDays'
import formatDistanceStrict from 'date-fns/formatDistanceStrict'
import endOfDay from 'date-fns/endOfDay'
import {
  longMonthDayFormat,
  safeParse as parseDate,
  safeFormat as formatDate,
} from 'lib/family-cup-utils/event-dates'
import { Status } from 'components/search/result-card'
import { getAlgoliaTimestamp } from 'lib/date-utils'

function registrationStatus(hit) {
  const comparisonTimestamp = getAlgoliaTimestamp()
  const inProgress =
    hit.event_start_ts < comparisonTimestamp &&
    hit.event_end_ts > comparisonTimestamp
  const isComplete =
    hit.event_end_ts < comparisonTimestamp &&
    hit.registration_close_ts < comparisonTimestamp

  if (isComplete) {
    return 'Complete'
  }

  if (inProgress) {
    return 'In Progress'
  }

  const closeDate = endOfDay(parseDate(hit.registration_close))
  const today = endOfDay(new Date())
  const difference = differenceInDays(closeDate, today)

  if (difference === 0) {
    return 'Registration closes today'
  }

  if (difference < 0) {
    return 'Registration closed'
  }

  if (difference <= 7) {
    return `Registration closing in ${formatDistanceStrict(closeDate, today)}`
  }

  return `Register by: ${formatDate(closeDate, longMonthDayFormat)}`
}

export default function RegistrationStatus({ hit }) {
  return (
    <Status
      borderColor="card.status.border"
      color="card.status.text"
      variant="outlined"
    >
      {registrationStatus(hit)}
    </Status>
  )
}
